const EDC = 'https://w3id.org/edc/v0.0.1/ns/';

export const AssetProperty = {
  id: `${EDC}id`,
};
